import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'ItemSeparator',
  components: {
    AzIcon: AzIcon
  },
  props: {
    separatorType: String
  }
});